import PayButton from './elements/pay_button'
import ClipboardCopy from './elements/copy_to_clipboard'
import ApiClipboardCopy from './elements/api_copy_to_clipboard'
import SetEuLink from './elements/set_eu_link'
import ApiSnippet from './elements/api_snippet'
import EmbedSnippet from './elements/embed_snippet'
import ToggleVisible from './elements/toggle_visible'
import Plausible from 'plausible-tracker'
import ProcessCheckout from './elements/process_checkout'
import FileDropzone from './elements/file_dropzone'
import CarouselItem from './elements/carousel_item'
import MenuActive from './elements/menu_active'
import HighlightVisible from './elements/highlight_visible'
import ToggleOnChange from './elements/toggle_on_change'
import ApiServerSelect from './elements/api_server_select'
import EmbedAttributeToggle from './elements/embed_attribute_toggle'
import RoughNotation from './elements/rough_notation'
import TestimonialShowMoreButton from './elements/testimonial_show_more_button'
import MergePdfForm from './elements/merge_pdf_form'
import LanguageSelector from './elements/language_selector'
import PatchArchor from './elements/patch_anchor'
import PatchHiddenAnchor from './elements/patch_hidden_anchor'
import SearchModal from './elements/search_modal'
import TurboStream from './elements/turbo_stream'
import PropertyList from './elements/property_list'
import RedirectHash from './elements/redirect_hash'
import OpenDialog from './elements/open_dialog'
import OpenPrompt from './elements/open_prompt'
import ScrollRail from './elements/scroll_rail'
import CodeSnippet from './elements/code_snippet'
import ContactForm from './elements/contact_form'
import AutoresizeTextarea from './elements/autoresize_textarea'
import TurboModal from './elements/turbo_modal'
import OpenModal from './elements/open_modal'
import OpenSearch from './elements/open_search'
import OpenChat from './elements/open_chat'
import ScrollTo from './elements/scroll_to'

const safeRegisterElement = (name, element, options = {}) => !window.customElements.get(name) && window.customElements.define(name, element, options)

safeRegisterElement('pay-button', PayButton)
safeRegisterElement('clipboard-copy', ClipboardCopy)
safeRegisterElement('api-clipboard-copy', ApiClipboardCopy)
safeRegisterElement('set-eu-link', SetEuLink)
safeRegisterElement('api-snippet', ApiSnippet)
safeRegisterElement('embed-snippet', EmbedSnippet)
safeRegisterElement('toggle-visible', ToggleVisible)
safeRegisterElement('process-checkout', ProcessCheckout)
safeRegisterElement('file-dropzone', FileDropzone)
safeRegisterElement('carousel-item', CarouselItem)
safeRegisterElement('menu-active', MenuActive)
safeRegisterElement('highlight-visible', HighlightVisible)
safeRegisterElement('toggle-on-change', ToggleOnChange)
safeRegisterElement('api-server-select', ApiServerSelect)
safeRegisterElement('embed-attribute-toggle', EmbedAttributeToggle)
safeRegisterElement('testimonial-show-more-button', TestimonialShowMoreButton)
safeRegisterElement('rough-notation', RoughNotation)
safeRegisterElement('merge-pdf-form', MergePdfForm)
safeRegisterElement('patch-anchor', PatchArchor)
safeRegisterElement('patch-hidden-anchor', PatchHiddenAnchor)
safeRegisterElement('search-modal', SearchModal)
safeRegisterElement('turbo-stream', TurboStream)
safeRegisterElement('property-list', PropertyList)
safeRegisterElement('redirect-hash', RedirectHash)
safeRegisterElement('open-dialog', OpenDialog)
safeRegisterElement('open-prompt', OpenPrompt)
safeRegisterElement('scroll-rail', ScrollRail)
safeRegisterElement('code-snippet', CodeSnippet)
safeRegisterElement('contact-form', ContactForm)
safeRegisterElement('autoresize-textarea', AutoresizeTextarea)
safeRegisterElement('turbo-modal', TurboModal)
safeRegisterElement('open-modal', OpenModal)
safeRegisterElement('open-search', OpenSearch)
safeRegisterElement('open-chat', OpenChat)
safeRegisterElement('scroll-to', ScrollTo)
safeRegisterElement('language-selector', LanguageSelector)

document.addEventListener('keyup', (e) => {
  if (e.code === 'Escape') {
    document.activeElement?.blur()
  }
})

const modalVideoHTML = `
  <div class="fixed z-50 top-0 bottom-0 right-0 left-0 overflow-y-auto" aria-labelledby="modal-title" role="modal" aria-modal="true">
    <div class="flex justify-center pt-8 px-4 text-center sm:block sm:p-0">
      <div class="fixed top-0 bottom-0 right-0 left-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" data-role="close-modal"></div>

      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <div class="inline-block align-bottom text-left overflow-hidden transform transition-all sm:align-middle sm:max-w-5xl sm:w-full">
        <video src="/demo.mp4" controls autoplay width="100%" class="rounded-lg shadow-xl"></video>
        <div class="mt-4 flex justify-center space-x-2">
        <span class="hidden md:inline">
        <a href="#" data-role="close-modal" class="btn btn-neutral font-normal text-base-100 normal-case w-44 h-14 text-xl">
          <span class="text-xl">
            &larr;
          </span>
          Back</a>
          </span>
          <a href="https://docuseal.com/sign_up" class="btn btn-outline border-2 bg-white font-medium normal-case w-72 h-14 text-xl" data-role="app-link" data-event="Click Sign Up" data-event-props="{&quot;location&quot;:&quot;Demo video on the landing page&quot;}">
            🚀 Create Free Account</a>
          </a>
        </div>
      </div>
    </div>
  </div>
  `

safeRegisterElement('set-video-modal', class extends HTMLElement {
  connectedCallback () {
    document.getElementById(this.dataset.triggerId).addEventListener('click', (e) => {
      e.preventDefault()

      window.history.pushState({}, '', '#demo')

      openVideoModal()
    })

    document.addEventListener('keyup', this.onEscKey)
  }

  disconnectedCallback () {
    document.removeEventListener('keyup', this.onEscKey)
  }

  onEscKey = (e) => {
    if (e.code === 'Escape') {
      closeModal()
    }
  }
})

function openVideoModal () {
  let container = document.querySelector('[data-role="modal"]')

  if (!container) {
    container = document.createElement('div')
    container.setAttribute('data-role', 'modal')

    container.innerHTML = modalVideoHTML
  }

  container.querySelectorAll('[data-role="close-modal"]').forEach((e) => {
    e.addEventListener('click', (el) => {
      el.preventDefault()
      closeModal()
    })
  })

  document.body.appendChild(container)

  initTrackingEventListenersOnPage()
}

function closeModal () {
  if (window.location.hash) {
    window.history.replaceState(window.history.state, '', '#')
  }

  if (document.querySelector('[data-role="modal"] video')) {
    document.querySelector('[data-role="modal"] video').pause()
  }

  if (document.querySelector('[data-role="modal"]')) {
    document.querySelector('[data-role="modal"]').remove()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#demo') && document.location.hash === '#demo') {
    openVideoModal()
  }
})

// Plausible Analytics

const plausible = Plausible({
  apiHost: 'https://plausible.docuseal.tech',
  domain: 'www.docuseal.com'
})

window.plausible = plausible
window.originalReferrer ||= document.referrer

if (process.env.NODE_ENV === 'production') {
  plausible.enableAutoPageviews()
}

function addTrackingEventListener (element) {
  const eventName = element.getAttribute('data-event')
  const eventProps = element.getAttribute('data-event-props')
  const parsedEventProps = eventProps && JSON.parse(eventProps)

  if (eventName) {
    element.setAttribute('data-event-initialized', true)
    element.addEventListener('click', function () {
      plausible.trackEvent(eventName, { props: parsedEventProps })
    })
  }
}

function initTrackingEventListenersOnPage () {
  document.querySelectorAll('[data-event]:not([data-event-initialized])').forEach(function (element) {
    addTrackingEventListener(element)
  })
}

function onhashchange (e) {
  if (e.newURL.includes('#demo')) {
    openVideoModal()
  } else {
    closeModal()
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.endsWith('/')) {
    document.addEventListener('hashchange', onhashchange)
  } else {
    document.removeEventListener('hashchange', onhashchange)
  }

  initTrackingEventListenersOnPage()
})

if (!HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) {
  const preloadedUrls = {}

  function pointerenterHandler () {
    if (!preloadedUrls[this.href]) {
      preloadedUrls[this.href] = true

      const prefetcher = document.createElement('link')

      prefetcher.as = prefetcher.relList.supports('prefetch') ? 'document' : 'fetch'
      prefetcher.rel = prefetcher.relList.supports('prefetch') ? 'prefetch' : 'preload'
      prefetcher.href = this.href

      document.head.appendChild(prefetcher)
    }
  }

  document.querySelectorAll('a[href^="/"]').forEach(item => {
    item.addEventListener('pointerenter', pointerenterHandler)
  })
}
